module.exports = __webpack_public_path__ + "static/media/ReportActiveIcon.80ad66b4.svg";